import cx from 'clsx';

import { Range, ranges, selectCustomRangeHandler } from '../../lib/selectCustomRangeHandler';
import { RangeChangeMeta } from '../../lib/types';
import { CustomRangeSelectListItem } from '../CustomRangeSelectListItem/CustomRangeSelectListItem';

import styles from './CustomRangeSelectList.module.scss';

type RangePickerSelectListProps = RangeChangeMeta & {
  activeRange?: Range | null;
  className?: string;
};

const rangeLabels: Record<Range, string> = {
  ThisWeek: 'This Week',
  LastWeek: 'Last Week',
  ThisMonth: 'This Month',
  LastMonth: 'Last Month',
  ThisQuarter: 'This Quarter',
  LastQuarter: 'Last Quarter',
  ThisYear: 'This Year',
  LastYear: 'Last Year',
};

export const CustomRangeSelectList = ({ className, ...props }: RangePickerSelectListProps) => {
  return (
    <ul className={cx(styles.list, className)}>
      {ranges.map((range) => (
        <CustomRangeSelectListItem
          key={range}
          active={props.activeRange === range}
          onSelectHandler={() => selectCustomRangeHandler(range, props)}
        >
          {rangeLabels[range]}
        </CustomRangeSelectListItem>
      ))}
    </ul>
  );
};
